import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { class: "notification-entry__content" }
const _hoisted_3 = {
  key: 0,
  class: "notification-entry__dot"
}
const _hoisted_4 = { class: "notification-entry__body" }
const _hoisted_5 = { class: "notification-entry__message" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "notification-entry__timestamp" }

import { computed } from 'vue';
import { useTimezoneStore } from '@/stores/timezone';
import { formatTimestamp } from '@/utils/dt';

interface Props {
    message: string
    boldSegments: string[]
    createdAt: number
    isRead: boolean
    href: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationEntry',
  props: {
    message: {},
    boldSegments: {},
    createdAt: {},
    isRead: { type: Boolean },
    href: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;
const emit = __emit;

const tzStore = useTimezoneStore();

const formattedTimestamp = computed(() =>
    formatTimestamp(new Date(props.createdAt * 1000), tzStore.effectiveTimezone),
);

const renderedSegments = computed(() => {
    const { message, boldSegments } = props;
    if (!boldSegments.length) return [{ text: message, bold: false }];

    const pattern = boldSegments
        .map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        .join('|');
    const regex = new RegExp(`(${pattern})`, 'gi');
    const parts = message.split(regex);

    const boldLower = new Set(boldSegments.map((s) => s.toLowerCase()));

    return parts
        .filter((p) => p.length > 0)
        .map((p) => ({
            text: p,
            bold: boldLower.has(p.toLowerCase()),
        }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification-entry", {
            'notification-entry--read': __props.isRead,
            'notification-entry--clickable': !!__props.href,
        }]),
    role: "button",
    tabindex: __props.href ? 0 : undefined,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('click')), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.isRead)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderedSegments.value, (seg, idx) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
              (seg.bold)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(seg.text), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(seg.text), 1)
                  ], 64))
            ], 64))
          }), 128))
        ]),
        _createElementVNode("span", _hoisted_7, _toDisplayString(formattedTimestamp.value), 1)
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "notification-entry__separator" }, null, -1))
  ], 42, _hoisted_1))
}
}

})